import English from './English/namespaces';

const translations = { English };

export default translations;
